export enum TOAST_TYPES {
	TIMED = 'timed_toaster',
	ACKNOWLEDGE = 'acknowledge_toaster',
	ACTION = 'action_toaster'
};

export interface IUCCToasterParams {
	Type?: TOAST_TYPES;
	MessageID: string | number;
	GameTypeID?: string | number;
	Title: string;
	SubTitle: string;
	DurationInSec: number;
	MobileImage: string;
	PCImage: string;
	IconImagePath: string;
	customUIConfig: string;
	ResponseTopicPath: string;
	MetaDataParams: string | null;
	analyticsData: {
		category: string;
		action: string;
		label?: string;
	};
	LangIso3: string;
	close: boolean;
	buttonText: string;
	callback: () => void;
	layout: number;
}

export interface IFirebaseToasterService {}
